//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data: ({value}) => ({
    formData: {
      zoeken: value,
    },
  }),
  watch: {
    value(val) {
      if (val !== this.formData.zoeken) {
        this.formData.zoeken = val;
      }
    },
  },
  methods: {
    onSearch(data) {
      this.$emit('input', data.zoeken);
    },
  },
};
